<div class="andn-layout">
	<div class="andn-main">
		<div class="andn-inner">

			<!-- ANDON grid -->
			<div class="andn-grid" *ngIf="departmentOverview?.length">
				<div class="andn-card" *ngFor="let dept of departmentOverview" [attr.data-deptkey]="dept.deptKey"
					[ngClass]="{
            'andn-card--ok': dept.status === 'green',
            'andn-card--supervisor': dept.status === 'supervisorrequired',
            'andn-card--breakdown': dept.status === 'breakdown',
            'andn-card--flashing': dept.status === 'supervisorrequired',
            'andn-card--breakdownflashing': dept.status === 'breakdown'
          }">
					<div class="andn-card-top">
						<i class="andn-icon" [ngClass]="getDepartmentIconClass(dept.departmentName)"></i>
						<h2 class="andn-dept-name">{{ dept.departmentName | uppercase }}</h2>
					</div>

					<!-- Pills (MULTIPLE) -->
					<div class="andn-card-bottom"
						*ngIf="(dept.breakdownMachineCodes?.length || 0) > 0 || (dept.supervisorMachineCodes?.length || 0) > 0">
						<!-- Breakdown row (TOP) -->
						<div class="andn-pills andn-pills--breakdown" *ngIf="dept.breakdownMachineCodes?.length">
							<div class="andn-machine-pill andn-machine-pill--breakdown"
								*ngFor="let code of dept.breakdownMachineCodes">
								<p class="andn-machine-code">{{ code }}</p>
							</div>
						</div>

						<!-- Assistance row (BOTTOM) -->
						<div class="andn-pills andn-pills--assist" *ngIf="dept.supervisorMachineCodes?.length">
							<div class="andn-machine-pill" *ngFor="let code of dept.supervisorMachineCodes">
								<p class="andn-machine-code">{{ code }}</p>
							</div>
						</div>
					</div>

				</div>
			</div>

			<!-- Fullscreen animated overlay -->
			<div class="andn-overlay" *ngIf="expandedDept && overlayStart"
				[class.andn-overlay--expanded]="overlayExpanded" [style.--startTop.px]="overlayStart.top"
				[style.--startLeft.px]="overlayStart.left" [style.--startWidth.px]="overlayStart.width"
				[style.--startHeight.px]="overlayStart.height">
				<div class="andn-card andn-overlay-card" [ngClass]="{
            'andn-card--supervisor': expandedDept.status === 'supervisorrequired',
            'andn-card--breakdown': expandedDept.status === 'breakdown',
            'andn-card--flashing': expandedDept.status === 'supervisorrequired',
            'andn-card--breakdownflashing': expandedDept.status === 'breakdown'
          }">
					<div class="andn-card-top">
						<i class="andn-icon" [ngClass]="getDepartmentIconClass(expandedDept.departmentName)"></i>
						<h2 class="andn-dept-name">{{ expandedDept.departmentName | uppercase }}</h2>
					</div>

					<!-- Overlay pills (MULTIPLE) -->
					<div class="andn-card-bottom" *ngIf="
              (expandedDept.breakdownMachineCodes?.length || 0) > 0 ||
              (expandedDept.supervisorMachineCodes?.length || 0) > 0
            ">
						<div class="andn-pills">
							<div class="andn-machine-pill andn-machine-pill--breakdown"
								*ngFor="let code of expandedDept.breakdownMachineCodes">
								<p class="andn-machine-code">{{ code }}</p>
							</div>

							<div class="andn-machine-pill" *ngFor="let code of expandedDept.supervisorMachineCodes">
								<p class="andn-machine-code">{{ code }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Empty -->
			<div class="andn-empty" *ngIf="!departmentOverview?.length && !isLoading">
				<p>No departments found.</p>
			</div>

		</div>
	</div>
</div>